<template>
  <div class="user-reports" >
    <div class="top-bar">
      <div class="count-reports">
        Show
        <el-select
            v-model="countItemInTable"
            @change="changeCount"
            size="small">
          <el-option
              v-for="item in countItmes"
              :key="item.value"
              :label="item.value"
              :value="item.value"
          >
          </el-option>
        </el-select>
        entries
      </div>
      <div>
        <el-select v-model="reportsType" placeholder="Type of reports" @change="changeType">
          <el-option
              v-for="item in reportTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>

      </div>
    </div>
    <div ref="tab">
      <el-table :data="userScans.data">
        <el-table-column
            label="Id scan"
            width="100">
          <template slot-scope="scope">
            #<span style="margin-left: 3px">{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Network"
            min-width="200"
            v-if="!reportsType || reportsType == 'monthly'">
          <template slot-scope="scope">
            <span>{{ scope.row.network_groups_name }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Service Type"
            min-width="200"
            v-if="reportsType == 'locator'">
          <template slot-scope="scope">
            <span>{{ scope.row.type }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Request"
            min-width="200"
            v-if="reportsType == 'locator'">
          <template slot-scope="scope">
            <span>{{ scope.row.request }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Email"
            min-width="200"
            v-if="!reportsType || reportsType == 'monthly'">
          <template slot-scope="scope">
            <span>{{ scope.row.email }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Name" v-if="reportsType === 'tinder'">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Min age" v-if="reportsType === 'tinder'">
          <template slot-scope="scope">
            <span>{{ scope.row.min_age }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Max age" v-if="reportsType === 'tinder'">
          <template slot-scope="scope">
            <span>{{ scope.row.max_age }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Location" v-if="reportsType === 'tinder'">
          <template slot-scope="scope">
            <span>{{ scope.row.location_address }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Status" v-if="reportsType === 'tinder'">
          <template slot-scope="scope">
            <span v-if="scope.row.finished == 1">Finished</span>
            <span v-else>Not finished</span>
          </template>
        </el-table-column>

        <el-table-column label="Gender" v-if="reportsType === 'tinder'">
          <template slot-scope="scope">
            <span>{{ scope.row.gender }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Created at"
            align="right">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Operations"
            align="right">
          <template slot-scope="scope">
            <el-button
                v-if="reportsType !== 'locator'"
                size="mini"
                @click="handleView(scope.row)">View
            </el-button>
            <div class="pdf-btn">
              <el-button
                  :disabled="isLoading(scope.row.id)"
                  :loading="isLoading(scope.row.id)"
                  size="mini"
                  type="danger"
                  v-if="reportsType !== 'tinder'"
                  @click="downloadImage(scope.row)">
                <template v-if="reportStatus.reportId !== scope.row.id">
                  Download
                </template>
              </el-button>
            </div>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagin-wrp">
        <el-pagination
            v-if="userScans"
            background
            layout="prev, pager, next"
            @current-change="chosePage"
            :page-size="1"
            :total="lastPage">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import html2canvas from 'html2canvas';
import {removeMicroToken} from "@/servises/microToken";

export default {
  name: 'UserScans',
  props: {
    isScreenProcess: Boolean,
    isReportScreenProcess: Boolean,
    screenshotPage: HTMLDivElement
  },
  data () {
    return {
      count_type:1,
      reportsType: null,
      countItemInTable:15,
      countItmes: [
        {value: 15},
        {value: 30},
        {value: 100},
      ],
      reportTypes: [
        { value: 'monthly',
          label: 'Monthly'
        },
        { value: 'locator',
          label: 'Locator'
        },
        { value: null,
          label: 'Single report'
        },
        { value: 'tinder',
          label: 'Tinder'
        },
      ],
      chosenPage: 1,
      countPerPage: 15,
    }
  },
  computed:{
    ...mapGetters({
      userScans : 'users/userScans'
    }),
    reportStatus() {
      return this.$store.state.users.reportStatus
    },
    lastPage(){
      if(this.userScans.meta){
        return this.userScans.meta.last_page
      }else{
        return 1
      }
    }
  },

  mounted () {
    this.getData()
    if (this.isScreenProcess && this.isReportScreenProcess) {
      setTimeout(() => {
        this.processPages()
      }, 4000)
      }
  },
  methods:{
    async processPages() {
      for (let i of [1, this.userScans.meta.last_page]) {
        this.chosenPage = i;
        await this.updateScansList();

        this.screenshotPage.style.overflow = 'visible';
        this.screenshotPage.style.height = 'auto';
        const canvas = await html2canvas(this.screenshotPage, {
          scrollX: 0,
          scrollY: -window.scrollY,
          width: this.screenshotPage.offsetWidth,
          height: this.screenshotPage.scrollHeight,
        });
        const imgURL = {
          url: canvas.toDataURL('image/png'),
          name: 'Reports-' + 'page_' + i,
        };

        this.$emit('addNewImage', imgURL);
        if (i === this.userScans.meta.last_page ) {
          this.$emit('togglePaymentInfo');
          this.$emit('triggerNextTab', 'paymentInfo');
        }

        if (this.userScans.meta.last_page === 1) {
          break;
        }
      }
    },
    changeType() {
      return this.updateScansList()
    },
    getData() {
      this.$store.dispatch('users/getUserScans', {
        userId: this.$route.params.id,
        pr: {
          type: this.reportsType,
          page: this.chosenPage,
          per_page: this.countPerPage
        }
      })

    },
    isLoading(id) {
      return this.reportStatus.isLoading && this.reportStatus.reportId === id
    },
    changeCount(e){
      this.countPerPage = e
      this.updateScansList()
    },
    chosePage(e){
      this.chosenPage = e
      this.updateScansList()

    },
    updateScansList(){
      let params = {};

      if (this.chosenPage) {
        params.page = this.chosenPage
      }
      if (this.countPerPage) {
        params.per_page = this.countPerPage
      }
      if (this.reportsType) {
        params.type = this.reportsType
      }
      return this.$store.dispatch('users/getUserScans', {
        userId: this.$route.params.id,
        pr: params
      }).then(response => {
        return Promise.resolve(response)
      })
    },
    handleView(row){
      (this.reportsType === 'tinder') ?
          this.$store.dispatch('users/getTinderReport', row) :
          this.$store.dispatch('users/getReport', row)
    },
    downloadImage(row){
      this.$store.dispatch('users/downloadImage', row)
    }
  }
}
</script>

<style lang="scss">
.user-reports {
  width: 98%;
  margin: 0 auto;
}
.pdf-btn {
  display: inline-block;
}
.pdf-btn .el-button {
  box-sizing: border-box;
  height: 28px;
  margin-left: 10px;
}
.count-reports{
  display: flex;
  align-items: center;
  justify-content: center;
  .el-select{
    width: 75px;
    margin: 0 5px;
  }
}
</style>
